import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export async function downloadExcel() {
  const id = toast.loading("Preparing the Excel backup…");
  try {
    const r = await api.get(`/export/excel?day=${new Date().toLocaleDateString("en-CA")}`, { responseType: "blob" });
    const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || "dentaflow_backup.xlsx";
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
    toast.success("Excel backup downloaded", { id });
  } catch (e) {
    toast.error(errMsg(e, "Could not prepare the export"), { id });
  }
}

export const notifyClinicUpdated = () => window.dispatchEvent(new Event("clinic-updated"));
